import React from "react";
import {
  ArrowDown,
  BadgeCheck,
  BookOpen,
  CalendarCheck,
  CalendarDays,
  ChartColumn,
  ChartLine,
  Check,
  ChevronDown,
  ChevronRight,
  CircleCheck,
  ClipboardList,
  Droplets,
  Fan,
  FileDown,
  FileText,
  Gauge,
  GraduationCap,
  Handshake,
  HardHat,
  Headphones,
  Headset,
  House,
  Layers,
  LifeBuoy,
  ListChecks,
  LucideIcon,
  Mail,
  Map,
  MapPin,
  Megaphone,
  MessageSquare,
  MessagesSquare,
  Minus,
  Network,
  Package,
  PhoneCall,
  Plug,
  Plus,
  Receipt,
  Rocket,
  Route,
  ShieldCheck,
  Smartphone,
  Star,
  Tag,
  TrendingUp,
  Trophy,
  UserCheck,
  Users,
  UserSearch,
  Video,
  Wrench,
  Zap,
} from "lucide-react";

/**
 * Lucide icons by the kebab-case names the CertainPath design system uses
 * (it renders lucide-static SVGs by name). Named imports keep the bundle to
 * the icons actually used — add new names here as pages need them.
 */
const ICONS: Record<string, LucideIcon> = {
  "arrow-down": ArrowDown,
  "badge-check": BadgeCheck,
  "book-open": BookOpen,
  "calendar-check": CalendarCheck,
  "calendar-days": CalendarDays,
  "chart-column": ChartColumn,
  "chart-line": ChartLine,
  check: Check,
  "chevron-down": ChevronDown,
  "chevron-right": ChevronRight,
  "circle-check": CircleCheck,
  "clipboard-list": ClipboardList,
  droplets: Droplets,
  fan: Fan,
  "file-down": FileDown,
  "file-text": FileText,
  gauge: Gauge,
  "graduation-cap": GraduationCap,
  handshake: Handshake,
  "hard-hat": HardHat,
  headphones: Headphones,
  headset: Headset,
  house: House,
  layers: Layers,
  "life-buoy": LifeBuoy,
  "list-checks": ListChecks,
  mail: Mail,
  map: Map,
  "map-pin": MapPin,
  megaphone: Megaphone,
  "message-square": MessageSquare,
  "messages-square": MessagesSquare,
  minus: Minus,
  network: Network,
  package: Package,
  "phone-call": PhoneCall,
  plug: Plug,
  plus: Plus,
  receipt: Receipt,
  rocket: Rocket,
  route: Route,
  "shield-check": ShieldCheck,
  smartphone: Smartphone,
  star: Star,
  tag: Tag,
  "trending-up": TrendingUp,
  trophy: Trophy,
  "user-check": UserCheck,
  users: Users,
  "user-search": UserSearch,
  video: Video,
  wrench: Wrench,
  zap: Zap,
};

export type CpIconName = keyof typeof ICONS;

interface CpIconProps {
  name: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
  style?: React.CSSProperties;
}

const CpIcon: React.FC<CpIconProps> = ({
  name,
  size = 20,
  color = "currentColor",
  strokeWidth = 2,
  style,
}) => {
  const Glyph = ICONS[name];
  if (!Glyph) return null;
  return (
    <Glyph
      aria-hidden="true"
      color={color}
      size={size}
      strokeWidth={strokeWidth}
      style={{ flex: "0 0 auto", display: "inline-block", ...style }}
    />
  );
};

export default CpIcon;
